interface EmptyNotificationIconProps {
  index: number;
}

const EMPTY_ICON_OPACITIES = [1, 0.75, 0.6, 0.35, 0.15];

export const EMPTY_NOTIFICATION_ICON_INDICES = [0, 1, 2, 3, 4];

const EmptyNotificationIcon: React.FC<EmptyNotificationIconProps> = ({ index }: EmptyNotificationIconProps) => {
  const opacity = EMPTY_ICON_OPACITIES[index] ?? 1;
  const uniqueId = `empty_notification_icon_${index}`;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="206" height="55" viewBox="0 0 206 55" fill="none" aria-hidden="true">
      <g opacity={opacity} filter={`url(#filter_${uniqueId})`}>
        <mask id={`mask_${uniqueId}`} style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="4" y="2" width="198" height="44">
          <path
            d="M195.033 2.30078H10.5332c-3.31371 0-6 2.68235-6 5.99119V39.7457c0 3.3089 2.68629 5.9912 6 5.9912H195.033c3.314 0 6-2.6823 6-5.9912V8.29197c0-3.30884-2.686-5.99119-6-5.99119Z"
            fill="white"
          />
        </mask>
        <g mask={`url(#mask_${uniqueId})`}>
          <path
            d="M195.033 2.30078H10.5332c-3.31371 0-6 2.68235-6 5.99119V39.7457c0 3.3089 2.68629 5.9912 6 5.9912H195.033c3.314 0 6-2.6823 6-5.9912V8.29197c0-3.30884-2.686-5.99119-6-5.99119Z"
            fill="#1D1C21"
          />
          <path
            d="M30.0332 37.4994c7.4558 0 13.5-6.0353 13.5-13.4802 0-7.4449-6.0442-13.4801-13.5-13.4801-7.4558 0-13.5 6.0352-13.5 13.4801 0 7.4449 6.0442 13.4802 13.5 13.4802Z"
            fill={`url(#paint0_${uniqueId})`}
          />
          <path
            d="M30.0332 37.4994c7.4558 0 13.5-6.0353 13.5-13.4802 0-7.4449-6.0442-13.4801-13.5-13.4801-7.4558 0-13.5 6.0352-13.5 13.4801 0 7.4449 6.0442 13.4802 13.5 13.4802Z"
            fill={`url(#paint1_${uniqueId})`}
          />
          <path
            d="M93.7832 18.0273h-36c-1.2426 0-2.25 1.0059-2.25 2.2467 0 1.2409 1.0074 2.2467 2.25 2.2467h36c1.2426 0 2.25-1.0058 2.25-2.2467 0-1.2408-1.0074-2.2467-2.25-2.2467Z"
            fill={`url(#paint2_${uniqueId})`}
          />
          <path
            d="M141.783 25.5176H57.7832c-1.2426 0-2.25 1.0059-2.25 2.2467 0 1.2408 1.0074 2.2467 2.25 2.2467h83.9998c1.243 0 2.25-1.0059 2.25-2.2467 0-1.2408-1.007-2.2467-2.25-2.2467Z"
            fill={`url(#paint3_${uniqueId})`}
          />
        </g>
        <path
          d="M195.033 2.30078H10.5332c-3.31371 0-6 2.68235-6 5.99119V39.7457c0 3.3089 2.68629 5.9912 6 5.9912H195.033c3.314 0 6-2.6823 6-5.9912V8.29197c0-3.30884-2.686-5.99119-6-5.99119Z"
          stroke="#626262"
          strokeOpacity="0.5"
          strokeWidth="0.6"
        />
      </g>
      <defs>
        <filter
          id={`filter_${uniqueId}`}
          x="0.000458241"
          y="0"
          width="205.565"
          height="54.503"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1.69318" />
          <feGaussianBlur stdDeviation="0.846589" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.121569 0 0 0 0 0.156863 0 0 0 0 0.215686 0 0 0 0.02 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result={`effect1_${uniqueId}`} />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="4.23295" />
          <feGaussianBlur stdDeviation="2.11647" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.121569 0 0 0 0 0.156863 0 0 0 0 0.215686 0 0 0 0.02 0" />
          <feBlend mode="normal" in2={`effect1_${uniqueId}`} result={`effect2_${uniqueId}`} />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="-2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.113725 0 0 0 0 0.109804 0 0 0 0 0.129412 0 0 0 1 0" />
          <feBlend mode="normal" in2={`effect2_${uniqueId}`} result={`effect3_${uniqueId}`} />
          <feBlend mode="normal" in="SourceGraphic" in2={`effect3_${uniqueId}`} result="shape" />
        </filter>
        <linearGradient id={`paint0_${uniqueId}`} x1="10.0058" y1="22.0008" x2="47.8354" y2="22.0008" gradientUnits="userSpaceOnUse">
          <stop stopColor="#2D2D2D" />
          <stop offset="0.48" stopColor="#3D3D3D" />
          <stop offset="0.992158" stopColor="#424242" stopOpacity="0.75" />
        </linearGradient>
        <linearGradient id={`paint1_${uniqueId}`} x1="10.0058" y1="22.0008" x2="47.8354" y2="22.0008" gradientUnits="userSpaceOnUse">
          <stop stopColor="#2D2D2D" />
          <stop offset="0.59" stopColor="#2D2D2D" stopOpacity="0.5" />
          <stop offset="0.992158" stopColor="#2D2D2D" stopOpacity="0.25" />
        </linearGradient>
        <linearGradient id={`paint2_${uniqueId}`} x1="45.742" y1="19.9376" x2="102.486" y2="19.9376" gradientUnits="userSpaceOnUse">
          <stop stopColor="#4F4F4F" />
          <stop offset="0.48" stopColor="#4F4F4F" />
          <stop offset="0.992158" stopColor="#2D2D2D" stopOpacity="0.75" />
        </linearGradient>
        <linearGradient id={`paint3_${uniqueId}`} x1="34.1377" y1="27.4279" x2="158.135" y2="27.4279" gradientUnits="userSpaceOnUse">
          <stop stopColor="#4F4F4F" />
          <stop offset="0.48" stopColor="#4F4F4F" />
          <stop offset="0.992158" stopColor="#2D2D2D" stopOpacity="0.75" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default EmptyNotificationIcon;
